import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

export default function NubbiMadnessRandom() {
  const [matchups, setMatchups] = useState([]);
  const [currentMatch, setCurrentMatch] = useState(0);
  const [round, setRound] = useState(1);
  const [nextWinners, setNextWinners] = useState([]);
  const [champion, setChampion] = useState(null);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    async function load() {
      const { data } = await supabase.from("characters").select("id, name, image");
      const valid = data.filter((c) => c.image && c.name);
      const shuffled = [...valid].sort(() => 0.5 - Math.random()).slice(0, 64);
      const firstRound = [];

      for (let i = 0; i < shuffled.length; i += 2) {
        firstRound.push([shuffled[i], shuffled[i + 1]]);
      }

      setMatchups(firstRound);
    }

    load();
  }, []);

  function handleVote(winner) {
    const updated = [...nextWinners, winner];
    setNextWinners(updated);

    if (currentMatch + 1 < matchups.length) {
      setCurrentMatch(currentMatch + 1);
    } else {
      if (updated.length === 1) {
        setChampion(updated[0]);
        return;
      }

      const newMatchups = [];
      for (let i = 0; i < updated.length; i += 2) {
        newMatchups.push([updated[i], updated[i + 1]]);
      }

      setTimeout(() => {
        setShowMessage(true);
        setTimeout(() => {
          setMatchups(newMatchups);
          setNextWinners([]);
          setCurrentMatch(0);
          setRound(round + 1);
          setShowMessage(false);
        }, 2000);
      }, 500);
    }
  }

  if (champion) {
    const shareUrl = `https://nubbiland.com/character/${champion.id}`;
    const encodedText = encodeURIComponent(`Check out the Nubbi Madness Champion: ${champion.name}`);
    const encodedURL = encodeURIComponent(shareUrl);

    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <h1>🏆 NUBBI MADNESS CHAMPION 🏆</h1>
        <img src={champion.image} alt={champion.name} style={{ width: 250, borderRadius: 20, marginTop: 20 }} />
        <h2>{champion.name}</h2>

        <div style={{ marginTop: 30, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <a href={`https://wa.me/?text=${encodedText}%20${encodedURL}`} target="_blank" rel="noreferrer" style={btn("#25D366")}>WhatsApp</a>
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`} target="_blank" rel="noreferrer" style={btn("#1877F2")}>Facebook</a>
          <a href={`mailto:?subject=Nubbi Madness Champion&body=${encodedText}%0A${shareUrl}`} style={btn("#D44638")}>Email</a>
          <button onClick={() => alert("Download and upload manually to Instagram")} style={btn("#C13584")}>Instagram</button>
        </div>
      </div>
    );
  }

  if (matchups.length === 0 || !matchups[currentMatch]) {
    return <p style={{ textAlign: "center", marginTop: 40 }}>Loading random bracket...</p>;
  }

  const [left, right] = matchups[currentMatch];

  const roundMessages = {
    2: "Ready for the Round of 32?",
    3: "Let’s go! Time for the Sweet 16!",
    4: "Elite 8 – The madness intensifies!",
    5: "Final Four survivors… brace yourself!",
    6: "THIS IS THE FINAL – Choose your Nubbi Champion!",
  };

  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      <h2>🔀 RANDOM NUBBI MADNESS</h2>
      {showMessage ? (
        <h3 style={{ marginTop: 40 }}>{roundMessages[round] || ""}</h3>
      ) : (
        <>
          <p>Round {round} – Match {currentMatch + 1} of {matchups.length}</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 40 }}>
            <div onClick={() => handleVote(left)} style={{ cursor: "pointer", width: 200 }}>
              <img src={left.image} alt={left.name} style={{ width: "100%", borderRadius: 12 }} />
              <h3>{left.name}</h3>
            </div>
            <div onClick={() => handleVote(right)} style={{ cursor: "pointer", width: 200 }}>
              <img src={right.image} alt={right.name} style={{ width: "100%", borderRadius: 12 }} />
              <h3>{right.name}</h3>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const btn = (bg) => ({
  backgroundColor: bg,
  color: "#fff",
  borderRadius: 10,
  padding: "10px 16px",
  fontWeight: "bold",
  cursor: "pointer",
  textDecoration: "none"
});